module.exports = "<header>\n    <dac-sidebar class=\"sn-bg-1 fixed\"></dac-sidebar>\n    <dac-navbar [doubleNav]=\"true\"></dac-navbar>\n</header>\n<main>\n    <div class=\"container-fluid mb-3\">\n        <dac-announcement-bar></dac-announcement-bar>\n        <router-outlet></router-outlet>\n        <dac-subscription-dialog></dac-subscription-dialog>\n    </div>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin/admin.component.html
// module id = ./src/app/admin/admin/admin.component.html
// module chunks = main